import { RefreshCw, WifiOff } from 'lucide-react';
import { Logo } from '@/components/brand';
import { Button } from './button';
import { useState } from 'react';

export function SessionCheckError({ onRetry, onReset }: { onRetry: () => void; onReset: () => void }) {
  const [confirmReset, setConfirmReset] = useState(false);
  const [error, setError] = useState('');
  return (
    <main className="session-recovery" aria-labelledby="session-recovery-title">
      <section className="session-recovery-card" role="alert">
        <div className="session-recovery-brand">
          <Logo />
        </div>
        <span className="session-recovery-icon" aria-hidden="true">
          <WifiOff size={24} />
        </span>
        <h1 id="session-recovery-title">{confirmReset ? 'Reset saved session?' : 'Unable to connect'}</h1>
        <p>
          {confirmReset
            ? 'This signs you out on this browser so you can log in again. Your account, calls, recordings and app preferences will stay unchanged.'
            : 'We couldn’t check your session. Check your connection and try again.'}
        </p>
        {confirmReset ? (
          <>
            <Button
              className="session-recovery-retry"
              onClick={() => {
                try {
                  onReset();
                } catch {
                  setError(
                    'Couldn’t reset the saved session. Check browser storage permissions and try again.',
                  );
                }
              }}
            >
              Reset and go to login
            </Button>
            <Button
              variant="ghost"
              onClick={() => {
                setConfirmReset(false);
                setError('');
              }}
            >
              Cancel
            </Button>
            {error && <p role="alert">{error}</p>}
          </>
        ) : (
          <>
            <Button className="session-recovery-retry" onClick={onRetry}>
              <RefreshCw size={16} />
              Try again
            </Button>
            <Button variant="ghost" className="session-recovery-reset" onClick={() => setConfirmReset(true)}>
              Reset saved session
            </Button>
            <small>Your saved session is still on this device.</small>
          </>
        )}
      </section>
    </main>
  );
}
